import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "data-id": "page-title",
  class: "truncate flex-1"
}

import { getRouteTitle } from '../../utils/routeUtils'
import { computed } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: undefined,
  },
  noBorder: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const route = useRoute()



const routeTitle = computed(() => getRouteTitle(route))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex-1 flex h-15 items-center overflow-hidden px-6", __props.noBorder || 'border-b'])
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(__props.title || _unref(routeTitle)), 1)
  ], 2))
}
}

})